import { forwardRef } from "react";
import logo from "../../assets/images/wp_logo.png";

const Logo = forwardRef<HTMLImageElement, React.ImgHTMLAttributes<HTMLImageElement>>((props, ref) => {
    return <img src={logo} alt="Waypoint by Navigator" width={160} {...props} ref={ref} />;
});

export default Logo;
